import palette from 'theme/palette';

export default {
  colorInherit: {
    backgroundColor: palette.black,
    color: palette.white,
  },
};
